import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=aaa5e6ea&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/h5-official/official/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa5e6ea"]])

export default __exports__